// Shared health-grid component used by Customer Retention + Service.
import type { ReactNode } from 'react';
import type { HealthStat } from '../mockData.js';

export interface HealthGridProps {
  title: string;
  subtitle: string;
  stats: HealthStat[];
  dataComponent: string;
}

export function HealthGrid({
  title,
  subtitle,
  stats,
  dataComponent,
}: HealthGridProps): ReactNode {
  return (
    <section className="exec-card" data-component={dataComponent}>
      <div className="exec-head">
        <h2>{title}</h2>
        <small>{subtitle}</small>
      </div>
      <div className="exec-body health-grid">
        {stats.map(stat => (
          <div
            key={stat.label}
            className={`health-stat${stat.tone !== 'default' ? ' ' + stat.tone : ''}`}
          >
            <span>{stat.label}</span>
            <strong>{stat.value}</strong>
            <small>{stat.caption}</small>
          </div>
        ))}
      </div>
    </section>
  );
}
